export default {
  name: 'purple',
  type: 'dark',
  colors: {
    'editor.background': '#4945ff',
    'editor.foreground': '#ffffff',
  },
  settings: [
    {
      scope: ['comment', 'block-comment', 'prolog', 'doctype', 'cdata'],
      settings: {
        foreground: '#999',
      },
    },
    {
      scope: ['punctuation'],
      settings: {
        foreground: '#ccc',
      },
    },
    {
      scope: ['tag', 'attr-name', 'namespace', 'deleted'],
      settings: {
        foreground: '#e2777a',
      },
    },
    {
      scope: ['function-name'],
      settings: {
        foreground: '#6196cc',
      },
    },
    {
      scope: ['boolean', 'number', 'function'],
      settings: {
        foreground: '#f08d49',
      },
    },
    {
      scope: ['property', 'class-name', 'constant', 'symbol'],
      settings: {
        foreground: '#f8c555',
      },
    },
    {
      scope: ['selector', 'important', 'atrule', 'keyword', 'builtin'],
      settings: {
        foreground: '#cc99cd',
      },
    },
    {
      scope: ['important'],
      settings: {
        fontWeight: 'bold',
      },
    },
    {
      scope: ['string', 'char', 'attr-value', 'regex', 'variable'],
      settings: {
        foreground: '#7ec699',
      },
    },
    {
      scope: ['operator', 'entity', 'url'],
      settings: {
        foreground: '#67cdcc',
      },
    },
    {
      scope: ['entity'],
      settings: {
        cursor: 'help',
      },
    },
    {
      scope: ['bold'],
      settings: {
        fontWeight: 'bold',
      },
    },
    {
      scope: ['italic'],
      settings: {
        fontStyle: 'italic',
      },
    },
    {
      scope: ['inserted'],
      settings: {
        foreground: 'green',
      },
    },
  ],
}
